<script lang="ts">
	import { _ } from 'svelte-i18n'
	// @ts-ignore
	import { version } from '../../../package.json'
</script>

<footer class="tc pv2 f6 lh-copy code">
	{$_('descriptions.footer')} <a href="https://www.lovoo.com/" rel="noopener" target="_blank">Lovoo</a> - v{version}
</footer>
